export enum SubscriptionOperationEnum {
  Renew = 'renew',
  Upsell = 'upsell',
  CompleteRenewal = 'complete-renewal',
  CompleteUpsell = 'complete-upsell',
}
